import { createMuiTheme } from '@material-ui/core/styles'

export const traceSVGcolor = '#285978'

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#0E0F12',
      darkBlue: '#285978',
      light: '#F7F7F7',
      lightAlternate: '#fcffff',
    },
    borders: {
      ghost: '#ecf4f2',
      cloud: '#e4eaec',
      cloudier: '#e5ebed',
      cloudiest: '#dbe1e3',
    },
    primary: {
      lighter: '#BAEBF0',
      light: '#43bdc9',
      mainLighter: '#2f6282',
      main: '#285978',
      mainDarker: '#21506e',
      dark: '#173446',
    },
    secondary: {
      light: '#77b8f4',
      main: '#226fb5',
      dark: '#13406a',
      contrastText: '#fff',
    },
    quote: '#72c49e',
    button: {
      callToAction: '#d10000',
    },
    inactive: '#cbcbcb',
    text: {
      main: '#333',
      soft: '#666',
      softBlue: '#526f82',
      light: '#999',
      lighter: '#cbcbcb',
      review: '#824160',
    },
    accent: {
      gray: '#e0dddd',
      noticeDark: '#8f3f1d',
      notice: '#b54d21',
      noticeLight: '#eb741e',
      noticeLighter: '#ff8c39',
    },
    error: {
      main: '#ff4545',
    },
    warning: '#c1632f',
    success: '#267d3b',
    successLighter: '#59ee51',
    featured: {
      onWhite: '#908200',
      onWhiteStrong: '#af6400',
    },
    link: {
      nav: '#373636',
      main: '#0070c2',
      mainDark: '#0075ff',
      hovering: '#7c04da',
      hoveringOnSecondary: '#a6efff',
      hoveringOnSecondaryDark: '#5bf0f9',
    },
    highlight: {
      lightTeal: '#5BCEFF',
    },
    social: {
      facebook: '#3b5998',
      twitter: '#1da1f2',
      youtube: '#ff0000',
      instagram: '#8a3ab9',
      pinterest: '#bd081c',
      linkedin: '#007bb5',
      googleplus: '#db4437',
      snapchat: '#fffc00',
      tumblr: '#35465d',
      reddit: '#ff4500',
      spotify: '#1ed760',
      amazon: '#ff9900',
      medium: '#02b875',
      vimeo: '#1ab7ea',
      skype: '#00aff0',
      quora: '#aa2200',
      yahoo: '#430297',
      deviantart: '#05cc47',
      vk: '#4a76a8',
    },
    amazon: '#ff9900',
    female: {
      author: '#a600ff',
    },
  },
})

export function pageStyle({ breakpoints }) {
  return {
    padding: '0 10px',
    color: '#333',
    lineHeight: 1.9,
    fontSize: '1.05em',
    fontWeight: 400,
    fontFamily: 'Roboto',
    [breakpoints.down('xs')]: {
      fontSize: '0.8em',
    },
  }
}

export default theme



// WEBPACK FOOTER //
// ./src/config/theme.js